module.exports = __webpack_public_path__ + "static/media/logo.b2ed1819.svg";